<template>
  <el-drawer
    :visible.sync="visible"
    :with-header="false"
    size="70%"
    custom-class="box-help-history-drawer"
  >
    <div class="drawer-head">
      <h2>装箱历史</h2>
      <button class="drawer-close" type="button" @click="close">×</button>
    </div>

    <div class="history-filter">
      <label>
        <span>装箱完成时间</span>
        <el-date-picker
          v-model="historyFilterTimeRange"
          type="datetimerange"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </label>
      <el-button type="primary" @click="searchHistory">查询</el-button>
      <el-button plain @click="resetHistoryFilter">重置</el-button>
    </div>

    <div class="drawer-table-wrap" v-loading="loading">
      <table class="history-table">
        <colgroup>
          <col class="history-col-no" />
          <col class="history-col-time" />
          <col class="history-col-small" />
          <col class="history-col-small" />
          <col class="history-col-outbound" />
          <col class="history-col-status" />
          <col class="history-col-actions" />
        </colgroup>
        <thead>
          <tr>
            <th>装箱单号</th>
            <th>装箱完成时间</th>
            <th>SKU 种类</th>
            <th>装箱数量</th>
            <th>马帮出库数量</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!historyList.length" class="empty-row">
            <td colspan="7">
              <div class="empty-box">
                <strong>暂无装箱历史</strong>
                <span>装箱完成后自动生成历史记录</span>
              </div>
            </td>
          </tr>
          <tr v-for="row in historyList" :key="row.packingNo">
            <td><span class="sku-code">{{ row.packingNo }}</span></td>
            <td>{{ row.completedAt }}</td>
            <td>{{ row.skuCount }}</td>
            <td><strong>{{ row.totalQty }}</strong></td>
            <td>
              <button class="link-btn strong-link" type="button" @click="$emit('open-log', row)">
                {{ row.outboundQty || 0 }}
              </button>
            </td>
            <td>
              <span :class="['status-tag', statusClass(row.outboundStatus)]">
                {{ row.outboundStatus }}
              </span>
            </td>
            <td>
              <div class="op-group">
                <button class="link-btn" type="button" @click="$emit('download', row)">下载装箱清单</button>
                <button class="link-btn" type="button" @click="$emit('outbound', row)">马帮出库</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="history-pagination" v-if="pagination.total > pagination.size">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pagination.current"
          :page-size="pagination.size"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "PackingHistoryDrawer",
  props: {
    historyList: {
      type: Array,
      // 父组件传入的装箱历史列表。
      default: () => [],
    },
    loading: {
      type: Boolean,
      // 父组件传入的历史接口加载状态。
      default: false,
    },
    pagination: {
      type: Object,
      // 父组件传入的分页信息。
      default: function () {
        return {
          // 当前页码。
          current: 1,
          // 每页条数。
          size: 20,
          // 总记录数。
          total: 0,
        };
      },
    },
  },
  data() {
    return {
      // 抽屉显示状态。
      visible: false,
      // 时间区间筛选控件当前选中的开始和结束时间。
      historyFilterTimeRange: [],
    };
  },
  methods: {
    // 供父组件通过 $refs 调用，打开装箱历史抽屉。
    open: function () {
      this.visible = true;
      this.emitQuery({
        pageNum: 1,
        pageSize: this.pagination.size,
      });
    },
    // 关闭装箱历史抽屉。
    close: function () {
      this.visible = false;
    },
    // 按当前时间区间筛选条件查询历史。
    searchHistory: function () {
      this.emitQuery({
        pageNum: 1,
        pageSize: this.pagination.size,
      });
    },
    // 清空时间区间筛选并重新查询历史。
    resetHistoryFilter: function () {
      this.historyFilterTimeRange = [];
      this.emitQuery({
        pageNum: 1,
        pageSize: this.pagination.size,
      });
    },
    // 切换每页条数后重新查询历史。
    handleSizeChange: function (pageSize) {
      this.emitQuery({
        pageNum: 1,
        pageSize,
      });
    },
    // 切换页码后查询对应页面。
    handleCurrentChange: function (pageNum) {
      this.emitQuery({
        pageNum,
        pageSize: this.pagination.size,
      });
    },
    // 向父组件发起历史查询请求。
    emitQuery: function (payload) {
      // 当前选择的历史查询时间区间。
      const timeRange = Array.isArray(this.historyFilterTimeRange) ? this.historyFilterTimeRange : [];
      // 历史查询参数。
      const params = {
        startDate: timeRange[0] || "",
        endDate: timeRange[1] || "",
        pageNum: payload.pageNum,
        pageSize: payload.pageSize,
      };
      this.$emit("query", params);
    },
    // 根据出库状态返回标签样式类名。
    statusClass: function (status) {
      if (status === "已出库") return "done";
      if (status === "出库失败") return "fail";
      return "pending";
    },
  },
};
</script>

<style scoped>
.drawer-head {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #dfe3ea;
}

.drawer-head h2 {
  margin: 0;
  font-size: 18px;
}

.drawer-close {
  width: 34px;
  height: 34px;
  border: 0;
  background: transparent;
  color: #596675;
  cursor: pointer;
  font-size: 26px;
}

.history-filter {
  min-height: 58px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-bottom: 1px solid #dfe3ea;
}

.history-filter label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #596675;
}

.drawer-table-wrap {
  height: calc(100vh - 116px);
  overflow: auto;
  padding: 16px 20px 24px;
}

.history-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.history-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  table-layout: fixed;
}

.history-col-no {
  width: 170px;
}

.history-col-time {
  width: 170px;
}

.history-col-small {
  width: 90px;
}

.history-col-outbound {
  width: 120px;
}

.history-col-status {
  width: 90px;
}

.history-col-actions {
  width: 190px;
}

.history-table th,
.history-table td {
  height: 48px;
  padding: 8px 12px;
  border: 1px solid #e8ebf0;
  text-align: left;
  vertical-align: middle;
}

.history-table th {
  height: 46px;
  background: #fafafa;
  color: #333333;
  font-weight: 700;
}

.empty-row td {
  height: 260px;
  text-align: center;
}

.empty-box {
  display: grid;
  gap: 10px;
  justify-items: center;
}

.empty-box strong {
  font-size: 14px;
  font-weight: 500;
  color: #b5bac2;
}

.empty-box span {
  color: #8c939d;
}

.sku-code {
  color: #1688ff;
  overflow-wrap: anywhere;
}

.op-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.link-btn {
  padding: 0;
  border: 0;
  background: transparent;
  color: #409eff;
  cursor: pointer;
}

.strong-link {
  font-weight: 700;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 700;
}

.status-tag.pending {
  background: #fff7e6;
  color: #c26a00;
}

.status-tag.done {
  background: #eef8e9;
  color: #55bf32;
}

.status-tag.fail {
  background: #fff1f0;
  color: #f5222d;
}

::v-deep .box-help-history-drawer {
  min-width: 760px;
}
</style>
